module.exports = __webpack_public_path__ + "static/media/Sugar Cube - Pink.e8f1e92f.png";